import { register } from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('featured-testimonials', {
  onLoad() {
    this.sliderId = '#testimonials__slider--' + this.id;
    const thisSlider = document.querySelector(
      '#testimonials__slider--' + this.id
    );

    const testimonialSlidesCount = Number(this.container.dataset.slides - 1);
    this.testimonialControllers = this.container.querySelector(
      '.controls-container--' + this.id
    );

    if (thisSlider) {
      var testimonialSlider = new Flickity(thisSlider, {
        prevNextButtons: false,
        pageDots: true,
        imagesLoaded: true,
        watchCSS: true,
      });

      const previousButton = this.testimonialControllers.querySelector(
        '.btn--control__prev'
      );
      previousButton.addEventListener('click', function() {
        testimonialSlider.previous();
      });

      const nextButton = this.testimonialControllers.querySelector(
        '.btn--control__next'
      );
      nextButton.addEventListener('click', function() {
        testimonialSlider.next();
      });

      testimonialSlider.on('change', function() {
        if (testimonialSlider.selectedIndex === 0) {
          previousButton.setAttribute('disabled', 'disabled');
          nextButton.removeAttribute('disabled');
        } else if (testimonialSlider.selectedIndex === testimonialSlidesCount) {
          nextButton.setAttribute('disabled', 'disabled');
          previousButton.removeAttribute('disabled');
        } else {
          nextButton.removeAttribute('disabled');
          previousButton.removeAttribute('disabled');
        }
      });
    }
  },
});
